import React, { useState, Component } from 'react';
import Chip from '../Atoms/Chip';



// function MediaCard() {
  
  

//     return <div className="bb br flex items- pos-relative height-25 max-h-300">
//         <img className={`w-100 br-${hoverRadius} ba fit-cover max-h-300`} src="images/featured-image.jpg" alt="Featured Work"/>
      
//         <Chip content="video" absolute="true" center="true"/>
//       </div>
    
//   //   <div className="w-90 bb flex br-medium items-bottom hidden">
//   //   <img className="w-100" src="images/featured-image.jpg" alt="Featured Work"/>
//   //   <TextBox firstLevel="p" secondLevel="i" thirdLevel="p" cx="pa-m pos-absolute "/>
//   // </div>


// }

// export default MediaCard;



///

class MediaCard extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);
    };

  

  render() {
    const {hoverRadius, border, url, category, chipLink} = this.props;
    

    return (
        <div className={`${border} media-card flex  w-100 pos-relative height-25 max-h-300 phone-height-250 phone-w-250 bb phone-br phone-bl`}>
          <img className={`w-100 br-${hoverRadius} ba fit-cover max-h-300 hover-animation-fast phone-height-250`} src={url} alt="Featured Work"/>
      
          <Chip linkTo={chipLink} content={category} absolute="true" center="true"/>
      </div>
    
    );
  }
}


export default MediaCard;